export default "__VITE_ASSET__ca6ffd4f__"